import React from 'react';
import { Link } from 'react-router-dom';

const formatDate = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  } catch {
    return '';
  }
};

const BlogCard = ({ post }) => {
  const { slug, title, excerpt, featured_image_url, featured_image_alt, category, author, author_name, published_at, reading_time_minutes } = post;
  const byline = author_name || author?.name || 'Dakhla Team';

  return (
    <Link
      to={`/blog/${slug}`}
      className="group bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 hover:-translate-y-0.5 transition-all duration-300 ease-out overflow-hidden flex flex-col focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
    >
      {/* 16:9 Thumbnail with smooth hover zoom */}
      <div className="relative aspect-video overflow-hidden bg-slate-100">
        {featured_image_url ? (
          <img
            src={featured_image_url}
            alt={featured_image_alt || title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-4xl font-black text-primary-600">
              {title.charAt(0).toUpperCase()}
            </span>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-4 sm:p-5 flex flex-col flex-1">
        {/* Category Pill */}
        <div className="mb-2.5">
          {category ? (
            <span className="inline-block px-2.5 py-0.5 bg-slate-100 text-[#1E256F] text-[11px] font-bold rounded-md border border-slate-200/80">
              {category.name}
            </span>
          ) : (
            <span className="inline-block text-[11px] font-semibold text-slate-400">General</span>
          )}
        </div>

        {/* Title */}
        <h3 className="text-[15px] font-bold text-slate-800 leading-snug line-clamp-2">
          {title}
        </h3>

        {/* Excerpt */}
        {excerpt && (
          <p className="mt-2 text-[13px] text-slate-500 leading-relaxed line-clamp-2">{excerpt}</p>
        )}

        {/* Streamlined Meta Row: Author name (left) · Date & Reading Time (right) */}
        <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between gap-2">
          <span className="text-[11px] font-semibold text-slate-700 truncate">
            {byline}
          </span>

          <div className="flex items-center gap-1.5 shrink-0 text-[11px] font-medium text-slate-400">
            {published_at && <span>{formatDate(published_at)}</span>}
            {published_at && <span>·</span>}
            <span>{reading_time_minutes || 1} min read</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
